export type Notification = {
  id: string;
  icon: string;
  title: string;
  read: boolean;
  permalink?: string;
  body?: string;
  type: NOTIFICATION_TYPE_ENUM;
  entityType: string;
  entityId: string;
  children?: Notification[];
  createdAt?: string;
};

export enum NOTIFICATION_TYPE_ENUM {
  CHAT = 'chat',
}

export type Toast = {
  id: string;
  title: string;
  permalink?: string;
  link?: string;
  createdAt: string;
};

export type ToastState = {
  id: string;
  notificationPayload: Toast;
  notificationTitle: string;
  notificationDelay: number;
  notificationType: string;
  permalink: string;
  hidden: 'show' | 'hide';
};
